// STP-77: Stepped backoff for the bundle-splitter status poll. Tabs left open
// for hours at a 2 s cadence accumulate too many entries in browser network
// logs / devtools and eventually crash. Slowing the cadence over time keeps
// initial responsiveness while drastically cutting long-session poll volume.

const POLL_STEPS: ReadonlyArray<{ untilMs: number; intervalMs: number }> = [
  { untilMs: 30_000, intervalMs: 2_000 }, // first 30 s — responsive
  { untilMs: 180_000, intervalMs: 5_000 }, // 30 s – 3 min
  { untilMs: 600_000, intervalMs: 10_000 }, // 3 – 10 min
];

const LONG_SESSION_INTERVAL_MS = 30_000; // > 10 min

export const computePollInterval = (elapsedMs: number): number => {
  for (const step of POLL_STEPS) {
    if (elapsedMs < step.untilMs) return step.intervalMs;
  }
  return LONG_SESSION_INTERVAL_MS;
};

// Watchdog fires when no `progress` advancement has been observed for this
// long. Independent of poll cadence so backoff can change freely without
// affecting the stuck detector.
export const STUCK_THRESHOLD_MS = 5 * 60_000;
